import type { BlockLayout } from "../models/ManualAuthoring";

/**
 * Allowed layouts when the block list is empty (first block)
 */
export const allowedAtStart: BlockLayout[] = [
  "paragraph",
  "subheading",
];

/**
 * Defines which layout can follow which layout
 */
export const allowedNext: Record<BlockLayout, BlockLayout[]> = {
  paragraph: [
    "paragraph",
    "paragraphIndented",
    "subheading",
    "step",
    "bulletList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  subheading: [
    "paragraph",
    "step",
    "bulletList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  paragraphIndented: [
    "paragraph",
    "paragraphIndented",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  step: [
    "paragraph",
    "subheading",
    "step",
    "subStep",
    "bulletList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  subStep: [
    "paragraph",
    "subheading",
    "step",
    "subStep",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  bulletList: [
    "paragraph",
    "subheading",
    "step",
    "bulletList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  numberList: [
    "paragraph",
    "subheading",
    "step",
    "numberList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  note: [
    "paragraph",
    "subheading",
    "step",
    "bulletList",
    "numberList",
    "note",
    "warning",
    "caution",
    "figure",
    "figureLeftTextRight",
    "figureRightTextLeft",
  ],

  warning: [
    "paragraph",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
  ],

  caution: [
    "paragraph",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
  ],

  figure: [
    "paragraph",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
    "figure",
  ],

  figureLeftTextRight: [
    "paragraph",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
    "figure",
  ],

  figureRightTextLeft: [
    "paragraph",
    "subheading",
    "step",
    "note",
    "warning",
    "caution",
    "figure",
  ],

  // Table is handled as a transparent block in rule engine.
  table: [],
};
